export default __webpack_public_path__ + "static/media/Zoe-Saunders.1d258b4f.jpg";